import { CommonModule } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    TemplateRef
} from '@angular/core';
import {
    ExpansionPanelComponent,
    ExpansionPanelConfig
} from '../expansion-panel/expansion-panel.component';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'nw-adviser-card',
    imports: [IconComponent, CommonModule, ExpansionPanelComponent],
    templateUrl: './adviser-card.component.html',
    styleUrl: './adviser-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdviserCardComponent implements OnChanges {
    @Input() actionBar!: TemplateRef<unknown>;
    @Input() name!: string;
    @Input() jobTitle!: string;
    @Input() email!: string;
    @Input() pictureUrl!: string;
    @Input({ transform: booleanAttribute }) isLoading: boolean = true;
    @Input({ transform: booleanAttribute }) isCardOpen: boolean = false;
    @Output() isCardOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    public isDefaultAdviser: boolean = false;
    public expansionPanelConfig: ExpansionPanelConfig = {
        open: false,
        shadow: true,
        tabIndex: undefined,
        chevron: {
            align: 'center',
            vertical: true
        },
        disableAnimations: true
    };

    private readonly DEFAULT_ADVISOR_NAME = 'Client Service Team';
    private readonly DEFAULT_ADVISOR_EMAIL = 'clientservice@netwealth.com';

    public ngOnChanges({ name, email, isCardOpen }: SimpleChanges): void {
        if ((name?.currentValue && this.email) || (email?.currentValue && this.name)) {
            this.isDefaultAdviser =
                this.name.toLowerCase() === this.DEFAULT_ADVISOR_NAME.toLowerCase() &&
                this.email.toLowerCase() === this.DEFAULT_ADVISOR_EMAIL.toLowerCase();
        }

        if (isCardOpen?.currentValue !== undefined)
            this.expansionPanelConfig = {
                ...this.expansionPanelConfig,
                open: isCardOpen.currentValue
            };
    }

    public onIsCardOpenToggle(isOpen: boolean): void {
        this.isCardOpen = isOpen;

        this.isCardOpenChange.emit(this.isCardOpen);
    }
}
